import { Box, Flex, Select } from '@radix-ui/themes';
import React from 'react';
import { useCreateResumeContext } from '../create-resume.context';
import {
  Autocomplete,
  FormField,
  MultiSelect,
  MultiSelectViewModel,
} from 'shared/components';
import { observer } from 'mobx-react-lite';
import { WorkTypeWithId } from './brain/work-types_search.vm';
import { toJS } from 'mobx';

export const DesiredPosition = observer(() => {
  const { desiredPosition } = useCreateResumeContext();
  return (
    <Box>

      {/* <FormField label="Бажана посада" error={''} required>
        <Autocomplete.Root
          name="country"
          valueKey={() => {
            return desiredPosition.position ?? '';
          }}
          onValueChange={(query) => {
            desiredPosition.onSearchPosition(query);
          }}
          // filter={(countryId, s) => {

          //   const position = countries.find((c) => c.id === Number(countryId));
          //   const match = country?.name.toLowerCase().includes(s.toLowerCase());
          //   return match ? 1 : 0;
          // }}
          onSelect={(countryId) => {
            // const country = countries.find((c) => c.id === Number(countryId));
          }}
        >
          {desiredPosition.positionOptions.map((position) => {
            return (
              <Autocomplete.Option value={position.id?.toString()} key={position.id}>
                {position.name}
              </Autocomplete.Option>
            );
          })}
        </Autocomplete.Root>
      </FormField> */}

      <FormField label="Бажана посада" required>
        <Select.Root value={desiredPosition.position}>
          <Select.Trigger></Select.Trigger>
          <Select.Content></Select.Content>
        </Select.Root>
      </FormField>

      <FormField label="Зайнятість" required>
        <MultiSelect.Root
          vm={desiredPosition.workTypes}
          placeholder="Виберіть зайнятість"
        >
          {desiredPosition.workTypes.results.map((wt) => {
            return (
              <MultiSelect.Option key={wt.id} value={wt}>
                {wt.label}
              </MultiSelect.Option>
            );
          })}
        </MultiSelect.Root>
      </FormField>
    </Box>
  );
});
